import Switch from "rc-switch"
import React from "react"
import "./WpSwitch.scss"

export default function WpSwitch({ ...props }) {
  return <Switch className="wp-switch" {...props} />
}
